// import { useState } from "react";
// import { useAuth } from "../../../context/AuthContext";
// import { useTelegram } from "../../../hooks/useTelegram";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import TelegramBottomNav from "./TelegramBottomNav";

// export default function Layout({ children }) {
//   const { user } = useAuth();
//   const { isTelegram } = useTelegram();

//   return (
//     <div className="min-h-screen flex flex-col bg-transparent relative">
//       {/* Top Navbar */}
//       {!isTelegram && (
//         <div className="sticky top-0 z-40 relative">
//           <Navbar />
//         </div>
//       )}

//       <div className="flex flex-1 relative z-10">
//         {/* Main content */}
//         <main
//           className={`relative flex flex-col flex-1 transition-all duration-300 ease-out
//           ${isTelegram ? "pb-20" : ""}`}
//         >
//           {/* content container - grows to fill space */}
//           <div className="w-full flex-1">{children}</div>

//           {!isTelegram && (
//             <div className="border-t bg-transparent backdrop-blur-sm mt-auto">
//               <Footer />
//             </div>
//           )}
//         </main>
//       </div>

//       {/* Telegram bottom nav */}
//       {isTelegram && user && <TelegramBottomNav />}
//     </div>
//   );
// }

import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useTelegram } from "../../../hooks/useTelegram";
import Navbar from "./Navbar";
import Footer from "./Footer";
import TelegramBottomNav from "./TelegramBottomNav";

export default function Layout({ children }) {
  const { user } = useAuth();
  const { isTelegram } = useTelegram();

  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Semi-transparent background for content readability */}
      {/* Semi-transparent background for content readability - Removed to show animation */}
      {/* <div className="absolute inset-0 bg-background/90 backdrop-blur-sm z-0" /> */}
      
      {/* Top Navbar */}
      {!isTelegram && (
        <div className="sticky top-0 z-40 relative">
          <Navbar />
        </div>
      )}

      <div className="flex flex-1 relative z-10">
        {/* Main content */}
        <main
          className={`relative flex flex-col flex-1 transition-all duration-300 ease-out
          ${isTelegram ? "pb-20" : ""}`}
        >
          {/* content container - grows to fill space */}
          <div className="w-full flex-1">{children}</div>

          {!isTelegram && (
            <div className="border-t bg-transparent backdrop-blur-sm mt-auto">
              <Footer />
            </div>
          )}
        </main>
      </div>

      {/* Telegram bottom nav */}
      {isTelegram && user && <TelegramBottomNav />}
    </div>
  );
}